import PostSearch from '@/views/commonPopup/PostSearch'
import CustSearch from '@/views/commonPopup/CustSearch'
export default [
    {
        path: '/commonPopup/postSearch/',
        name: 'post-search',
        component: PostSearch,
        meta: {
            auth: true,
            logging: true, // 로깅 여부
            pageName: '주소검색팝업', // 로깅 시 사용할 페이지명
        }
    },
    {
        path: '/commonPopup/custSearch/',
        name: 'cust-search',
        component: CustSearch,
        meta: {
            auth: true,
            logging: true, // 로깅 여부
            pageName: '고객검색팝업', // 로깅 시 사용할 페이지명
        }
    },
]